import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appRtcDetectionStep]'
})
export class RtcDetectionStepDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
